import { Text } from '@betterment/samba-react';

type CoverageCopyParams = {
  coverage: number;
  coverageMonthsCap: number;
};

export function formatCoverageCopy(coverage: number, coverageMonthsCap: number) {
  if (coverage === 0) return '';
  if (coverage < 1) return 'Less than 1 month of expenses';
  if (coverage > coverageMonthsCap) return `Over ${coverageMonthsCap} months of expenses`;

  return `${parseFloat(coverage.toFixed(1))} months of expenses`;
}

const CoverageCopy: React.FC<CoverageCopyParams> = ({ coverage, coverageMonthsCap }) => {
  const coverageCopy = formatCoverageCopy(coverage, coverageMonthsCap);
  return <Text color="text.weak">{coverageCopy}</Text>;
};

export default CoverageCopy;
